import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-remembertemp',
  templateUrl: './remembertemp.component.html',
  styleUrls: ['./remembertemp.component.css']
})
export class remembertempComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<remembertempComponent>, public router: Router) {
    //////console.log("hello")
  }

  @Input() username: string;
  ngOnInit() {
    this.dialogRef.updatePosition({
      top: `8px`,
      right: `16px`
    });
  }

  continue(): void {
    return this.dialogRef.close(null);

  }

  logout(): void {
    return this.dialogRef.close('remember');
  }

}
